export const avatarResizedKey = "180px";
